module.exports = __webpack_public_path__ + "static/media/page_04_a.5b2e26db.jpg";